import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Select, Checkbox } from "antd"
import queryString from "query-string"
import { listPartner } from "../../../../services/api/3dApi"
import { v4 as uuidV4 } from 'uuid'

const { Option } = Select

class BatchesPartnerSew extends Component {
    constructor(props) {
        super(props)

        this.state = {
            errPartner: '',
            partners: [],
        }
    }

    componentDidMount() {
        this._fetchPartners()
    }

    _fetchPartners = async () => {
        try {
            const payload = {
                type: 'sewing_partner',
                hidden: false,
                limit: 1000
            }
            const query = queryString.stringify(payload)

            const { data: response } = await listPartner(query)

            const { success, error, data } = response

            if (!success) {
                this.setState({
                    errPartner: error
                })

                return
            }

            const newPartners = data.partners.flatMap(partner => {
                if (partner.has_groups) {
                    return partner.groups.map(group => ({
                        ...partner,
                        ...group,
                        idx: uuidV4(),
                        partnerName: partner.name,
                        groupId: group._id,
                        partnerId: partner._id
                    }))
                }

                return { ...partner, idx: uuidV4(), partnerName: partner.name, partnerId: partner._id }
            })

            this.setState({
                errPartner: '',
                partners: newPartners
            })

        } catch (e) {
            this.setState({})
        }
    }

    _handleChangePartner = (name, value) => {
        const { onChangePartner, isSewingGroup = false, status = '', onChangeCheckBox } = this.props
        const { partners = [] } = this.state


        const listPartnerSelected = Array.isArray(partners) && partners.length > 0 ?
            partners.filter(p => value.includes(p.idx))
                .map(p => ({ sewing_partner: p.partnerId, sewing_group: p.groupId, }))
            : []

        onChangePartner({
            without_sewing_group: value.includes('without_sewing_group'),
            without_sewing_partner: value.includes('without_sewing_partner'),
            mutiple_sewing_partner: listPartnerSelected,
            // sewing_group: '',
            // sewing_partner: '',
            status: value.includes("without_sewing_group") ? 'sewing' : ((isSewingGroup && status === "sewing") ? '' : status)
        })

        if(value.includes('without_sewing_group')){
            onChangeCheckBox(false)
        }else{
            onChangeCheckBox(true)
        }
    }

    _handleChangeCheckbox = (checked) => {
        const { onChangeCheckBox } = this.props
        onChangeCheckBox(checked)
    }

    render() {
        const { partners } = this.state
        const { isShowSewingPartner = false, isSewingGroup = false, filters = {}, disabled = false } = this.props
        const { without_sewing_group = false, without_sewing_partner = false, mutiple_sewing_partner = [] } = filters || {}

        return (
            <div className='col-12 col-xl-2 mb-3'>
                <label className="font-weight-bold d-flex align-items-center justify-content-between">
                    Nhóm may
                    {/* {isSewingGroup && <Checkbox
                        className="ml-2"
                        onChange={() => this._handleChangeCheckbox(isShowSewingPartner)}
                        checked={isShowSewingPartner}
                    >Chưa có nhóm may</Checkbox>} */}
                </label>
                <Select
                    onChange={(value) => this._handleChangePartner('sewing_partner', value)}
                    defaultValue={[]} style={{ width: '100%' }}
                    placeholder="Nhóm may"
                    mode='multiple'
                    allowClear
                    showArrow
                    showSearch
                    disabled={disabled}
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    dropdownClassName='custom-select-partner'
                >
                    {/* <Option value=''>Tất cả</Option> */}
                    <Option value='without_sewing_group' disabled={without_sewing_partner || mutiple_sewing_partner.length > 0}>Chưa có nhóm may</Option>
                    <Option value='without_sewing_partner' disabled={without_sewing_group || mutiple_sewing_partner.length > 0}>Chưa có đối tác may</Option>
                    {
                        partners.length > 0 && partners.map(item => {
                            return (
                                <Option key={item.idx} value={item.idx} disabled={without_sewing_group || without_sewing_partner}>
                                    {
                                        !!item.has_groups ? `${item.partnerName} - ${item.name}` : item.name
                                    }
                                </Option>
                            )
                        })
                    }
                </Select>
            </div>
        )
    }
}

BatchesPartnerSew.propTypes = {
    onChangePartner: PropTypes.func.isRequired
}

export default BatchesPartnerSew
